const BlogButton = () => {
    return(
        <>
            <a href="https://664b1743a4f26b8131bcf43a--cheery-gingersnap-ebdf87.netlify.app/">
            <button style={{backgroundColor: "black", color: "yellow", marginLeft: "10px", marginTop: "20px", scale: "1", borderRadius: "10px", paddingLeft: "10px", paddingRight: "10px"}}>Blog</button>
            </a>
        </>
    )
}

export default BlogButton;